import React from 'react';
import {
  Button,
  Card,
  CardHeader,
  Col,
  Form, FormTextarea,
  ListGroup,
  ListGroupItem,
  Row
} from "shards-react";
import {useHistory, useLocation} from "react-router-dom";
import {setDateForTableInHrMinSec} from "../../utils/date";
import {default as queryString} from "qs";
function PensionNotes({
                          formData,
                          pensionNoteList,
                           formDataRef,
                           sectionformDataRef
                         }) {

  const history = useHistory();
  const location = useLocation();
  let queryParams = queryString.parse(location.search.replace("?", ""))


  var pensionNoteContent = pensionNoteList.map((note) => {
    return setDateForTableInHrMinSec(note.date) + ' by ' + note.userName + ' : ' + note.noteText;
  });

  pensionNoteContent = pensionNoteContent.join("\r\n");

  return (
    <Card id='pensionNotes' small className="mb-5 w-100">
        <span className="iconBox"><i className="fas fa-clipboard iconStyle"/></span>
      <label htmlFor="pensionNoteContent" className="m-0"><h4 className="m-0 section-title headerStyle">Pension Notes</h4></label>
      <CardHeader
        className="border-bottom d-flex align-items-center justify-content-end pt-0 mt-3">
        <Button size='sm'
                theme="accent" onClick={() => {formData.userId &&
          history.push({
            pathname: '/sub-add-edit-notes',
            search:`?role=${queryParams.role}`,
            state: {
              noteType: 2,
              noteTypeText: 'Pension Notes',
              userId: formData.userId,
              userName: formData.firstName + ' ' + formData.lastName,
              role:queryParams.role,
              formData,
              formDataRef, 
              sectionformDataRef
            },
          });
        }}>Add/Edit Notes</Button>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="px-3 pt-0">
          <Row>
            <Col className="pr-0">
              <Form>
                <Row form className="mr-0">
                  <FormTextarea id="pensionNoteContent" className="notes-textarea border-0 bg-white" readOnly rows="10" value={pensionNoteContent}/>
                </Row>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  );
}

export default PensionNotes;
